export default {
      id: "select-arrow-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#select-arrow",
      toString: function () {
        return this.url;
      }
    }